/**
 * Утилиты для проверки ролей пользователя.
 */
import { User } from '../types/auth';

// Имя роли администратора (совпадает с backend KEYCLOAK_ADMIN_ROLE).
export const ADMIN_ROLE = process.env.REACT_APP_ADMIN_ROLE || 'apibar-admin';

/**
 * Проверяет, обладает ли пользователь ролью администратора.
 */
export const isAdmin = (user: User | null): boolean => {
  return !!user && Array.isArray(user.roles) && user.roles.includes(ADMIN_ROLE);
};
